import { Injectable } from "@angular/core";
import { Router } from '@angular/router';

declare var $ :any;

@Injectable()
export class MensagemService {

    constructor(private router: Router) {

    }

    show = ( campos: string[]): void => {

        for(let campo of campos){
            $("." + campo + "Div").addClass( "error" );
            $("." + campo).attr("style","display:block");
        }
    }

    clear = () => {
        $(".input-field").removeClass( "error" );
        $(".txErro").attr("style","display:none");
    }

    servicoIndisponivel = (mensagem: string) => {
        sessionStorage.setItem("mensagem_erro", mensagem);
        this.router.navigate(['/erro']);
    }

    servicoIndisponivelPrimeiroAcesso = (mensagem: string) => {
      sessionStorage.setItem("mensagem_erro", mensagem);
      this.router.navigate(['/erro-primeiro-acesso']);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/services/mensagem.service.ts